import React, {useState, useEffect} from 'react';

import Preloader from '../../../../components/preloader/preloader.jsx';
import EmptyBox from '../../../../components/empty-box/empty-box.jsx';
import {useAppContext} from '../../../../app-context.js';
import {useRequest} from '../../../../common/hooks';
import {getEmployeeListReq} from '../../../../common/api/api.js';
import {filterArray} from '../../../../common/actions.js';

import Actions from './actions/actions.jsx';
import EmployeeList from './employee-list/employee-list.jsx';
import StaffContext from './staff-context.js';

const Staff = () => {
  const {employeeList, setEmployeeList, user} = useAppContext();

  const [visibleEmployeeList, setVisibleEmployeeList] = useState();
  const [search, setSearch] = useState('');

  const {request} = useRequest();

  const getEmployeeList = async () => {
    const res = await request(getEmployeeListReq(user.id));
    setEmployeeList(Object.values(res));
  };

  useEffect(() => {
    getEmployeeList();
  }, []);

  useEffect(() => {
    setVisibleEmployeeList(
      search
        ? filterArray(search, employeeList, ['fullname', 'email', 'phone'])
        : employeeList
    );
  }, [employeeList, search]);

  return (
    <StaffContext.Provider
      value={{
        search,
        setSearch,
        visibleEmployeeList
      }}
    >
      <div>
        <Actions
          setVisibleEmployeeList={setVisibleEmployeeList}
          getEmployeeList={getEmployeeList}
        />

        {visibleEmployeeList ? (
          visibleEmployeeList.length > 0 ? (
            <EmployeeList />
          ) : (
            <EmptyBox />
          )
        ) : (
          <Preloader />
        )}
      </div>
    </StaffContext.Provider>
  );
};

export default Staff;
